// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"527":"c3e6ea3d","566":"08efe85c","701":"c3e6ea3d","720":"ec11f7ac","735":"2d071668"}[chunkId] + ".chunk.css";
};